import PropTypes from 'prop-types'
import React from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import getOverallDifficulty from '../../../LearningPaths/LearningPathDetail/utils'
import './styles.css'

function MyLearningPath(props) {
  return (
    <div className="my-learning-path">
      <div className="clickable-overlay">
        <Link to={`/pathways/${props.slug}`} aria-label={props.title} />
      </div>
      <div className="left side">
        <div className="title">
          <span>{props.title}</span>
        </div>
        <div className="info">
          <div className="courses-amount">
            <i className="icon-stream" />
            <span>{props.numTutorials} Courses</span>
          </div>
          <div className="duration">
            <i className="icon-movies" />
            <div className="text">
              {props.duration && <span>{props.duration[0]}h </span>}
              <span>{props.duration[1]}m</span>
              <span>of duration</span>
            </div>
          </div>
          <div className="difficulty">
            <i className={`icon-level${_.max(props.difficulty)}`} />
            <span>{getOverallDifficulty(props.difficulty)}</span>
          </div>
        </div>
      </div>
      <div className="right side">
        <div style={{ backgroundImage: `url(${props.photo.default})` }} className="image" />
      </div>
    </div>
  )
}

export const LearningPathSummaryPropTypes = {
  title: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  photo: PropTypes.objectOf(PropTypes.string).isRequired,
  artist: PropTypes.shape({
    title: PropTypes.string.isRequired
  }),
  difficulty: PropTypes.arrayOf(PropTypes.number).isRequired,
  duration: PropTypes.arrayOf(PropTypes.number).isRequired,
  numTutorials: PropTypes.number.isRequired
}

MyLearningPath.propTypes = LearningPathSummaryPropTypes

export default MyLearningPath
